import withAemIntegration from "../../withAemIntegration";
import {
  ResponsiveGrid,
  withComponentMappingContext,
} from "@adobe/aem-react-editable-components";
import loadable from "../../utils/loadable";
import ComponentWrapper from "../component-wrapper";
import styled from "styled-components";
import React from "react";
const Component = loadable(() => import("@lexus.com/ui/dist/modules/Drawer"));

const DrawerEditConfig = {
  emptyLabel: "Drawer Module",
  isEmpty: (props) => !props?.children?.length,
};

const Editor = styled.h3`
  text-align: center;
`;

export class DrawerComponent extends ResponsiveGrid {
    render() {
        const { editorMode = false } = window;
        if (editorMode) {
            return (
                <Editor>
                    <h3>{this.props.label}</h3>
                    <ComponentWrapper>{super.childComponents}</ComponentWrapper>
                    {super.placeholderComponent}
                </Editor>
            );
        }
        return (
            <Component {...this.props}>
                {super.childComponents}
                {super.placeholderComponent}
            </Component>
        );
    }
}

const Drawer = withComponentMappingContext(DrawerComponent);
Drawer.displayName = 'Drawer'

export default withAemIntegration("lexus/components/drawer")(
  Drawer,
  DrawerEditConfig
);
